import { createAsyncThunk } from "@reduxjs/toolkit";
import { addToProcessingOrQueued, moveToReady } from "./slice";
import { AppDispatch } from "store/store";
import { RootState } from "store/reducers";
import { UploadProps, VideoUploadStatus } from "./types";
import { useSwitcherClientCore } from "hooks/useSwitcherClient";

const POLLING_INTERVAL = 10000;
let isPolling = false;

export const startPollingUpload = createAsyncThunk<
    void,
    UploadProps,
    {
        dispatch: AppDispatch;
        state: RootState;
    }
>("uploads/startPollingUpload", async (uploadProps, { dispatch }) => {
    dispatch(addToProcessingOrQueued(uploadProps));

    if (!isPolling) {
        isPolling = true;
        dispatch(pollPendingUploads());
    }
});

export const pollPendingUploads = createAsyncThunk<
    void,
    void,
    {
        dispatch: AppDispatch;
        state: RootState;
    }
>("uploads/pollPendingUploads", async (_, { getState, dispatch }) => {
    let { processingOrQueued } = getState().uploads;

    if (processingOrQueued.length > 0) {
        const { data: broadcasts } = useSwitcherClientCore(
            (client) => client.broadcasts_GetBroadcastsByIds,
            {
                suppressErrorBoundary: true,
                requestImmediately: true,
                args: [processingOrQueued.map((item) => item.broadcastId)]
            }
        );

        broadcasts.forEach((broadcast) => {
            const video = broadcast?.Videos[0];
            const broadcastId = broadcast.Details.Id;
            try {
                if (video.Details.Status === VideoUploadStatus.Success) {
                    dispatch(moveToReady({ broadcastId }));
                }
            } catch (error) {}
        });
    }

    setTimeout(() => {
        if (processingOrQueued.length > 0) {
            dispatch(pollPendingUploads());
        } else {
            isPolling = false;
        }
    }, POLLING_INTERVAL);
});
